import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService } from '../../../shared/services/base.service';
import { SummaryLoanModel } from '../models/summary-loan.model';



@Injectable()
export class LoanService extends BaseService<SummaryLoanModel,SummaryLoanModel> {
  constructor(http: HttpClient) {
    super(http, '/api/v2/loans');
  }

}
